import { useCreateIncidentContext, useUserLanguage } from '@/customHooks'
import textsData from '@/textData/CreateIncidentTexts.json'
import { PriorityOption } from '@/graphql/generated'
import { Col, Row } from 'react-grid-system'
import { NormalFormDateField, SquareButtonsCard } from '../molecules'
import lowPriorityIcon from '@/assets/incidents-icons/low-priority-icon.svg'
import mediumPriorityIcon from '@/assets/incidents-icons/medium-priority-icon.svg'
import highPriorityIcon from '@/assets/incidents-icons/high-priority-icon.svg'
import styled from 'styled-components'
import { RowSpacer } from '../atoms'
import { useEffect, useMemo } from 'react'

const FieldContainer = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.border.radius.lg};
  padding: 2rem;
  margin-bottom: 3rem;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  min-width: 360px;
  width: 550px;
`

export const SelectIncidentPriorityMenu = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es.incidentPriority : textsData.en.incidentPriority

  const { state, setPriority, setStartDate, setEndDate, setButtonEnabled, setButtonDisabled } = useCreateIncidentContext()

  const defaultSelectedIndex = useMemo(() => {
    switch (state.incidentPriority) {
      case PriorityOption.Low: return 0;
      case PriorityOption.Medium: return 1;
      case PriorityOption.High: return 2;
      default: return null;
    }
  }, [state.incidentPriority]);

  const buttons = [
    { text: texts.button.button1, icon: lowPriorityIcon },
    { text: texts.button.button2, icon: mediumPriorityIcon },
    { text: texts.button.button3, icon: highPriorityIcon },
  ];

  const onSelectedHandle = (value: number | null) => {
    // Si se selecciona una prioridad y no hay fecha de inicio, se establece la fecha actual.
    if (value !== null && !state.startDate) {
      setStartDate(new Date().toISOString());
    }

    switch (value) {
      case null:
        setButtonDisabled()
        break

      case 0:
        setPriority(PriorityOption.Low)
        setButtonEnabled()
        break
      
      case 1:
        setPriority(PriorityOption.Medium)
        setButtonEnabled()
        break

      case 2:
        setPriority(PriorityOption.High)
        setButtonEnabled()
        break
      
      default:
        throw new Error('Select value for IncidentType is invalid [SelectIncidentTypeMenuCard]')
    }
  }

  // Habilita o deshabilita el botón "Siguiente" basado en si hay una prioridad seleccionada en el contexto.
  useEffect(() => {
    if (state.incidentPriority) setButtonEnabled();
    else setButtonDisabled();
  }, [state.incidentPriority, setButtonEnabled, setButtonDisabled]);
  
  return (
    <>
      <Row justify="center">
        <Col xs='content'>
          <SquareButtonsCard
            buttons={buttons}
            onSelected={onSelectedHandle}
            defaultSelected={defaultSelectedIndex}
          />
        </Col>
      </Row>
      <RowSpacer height={3} />
      <Row justify="center">
        <Col xs="content">
          <FieldContainer>
            <NormalFormDateField
              label={texts.date.start}
              required
              value={state.startDate}
              onChange={setStartDate}
            />
            <NormalFormDateField
              label={texts.date.end}
              value={state.endDate}
              onChange={setEndDate}
            />
          </FieldContainer>
        </Col>
      </Row>
    </>
  );
}